import CheckOutPage from "components/checkout/CheckOutPage";
import ForgotPassword from "pages/auth/ForgotPassword";
import Login from "pages/auth/Login";
import ResetPassword from "pages/auth/ResetPassword";
import SignUp from "pages/auth/SignUp";
import ContactUs from "pages/contactUs/ContactUs";
import Analysis from "pages/dashbaord/analysis/Analysis";
import BillingDetails from "pages/dashbaord/billingDetails/BillingDetails";
import CreateSurvey from "pages/dashbaord/createSurvey/CreateSurvey";
import SurveyPreview from "pages/dashbaord/createSurvey/surveyPreview/SurveyPreview";
import SurveyTemplate from "pages/dashbaord/createSurvey/surveyTemplates/SurveyTemplate";
import DraftSurveys from "pages/dashbaord/draftSurveys/DraftSurveys";
import FeedbackSurvey from "pages/dashbaord/mySurveys/FeedbackSurvey";
import MySurveys from "pages/dashbaord/mySurveys/MySurveys";
import Support from "pages/dashbaord/support/Support";
import SurveyStatusReport from "pages/dashbaord/surveyStatusReport/SurveyStatusReport";
import UserProfile from "pages/dashbaord/UserProfile/UserProfile";
import Features from "pages/features/Features";
import AboutUs from "pages/homePage/AboutUs";
import HomePage from "pages/homePage/HomePage";
import PrivacyPolicy from "pages/homePage/PrivacyPolicy";
import TermCondition from "pages/homePage/TermCondition";
import ReceiveResponse from "pages/payment-response/ReceiveResponse";
import ReceiveSubscriptionResponse from "pages/payment-response/ReceiveSubscriptionResponse";
import PricingMode from "pages/pricing/PricingMode";

// Define routes for the auth section
const authRoutes = [
  { path: "/login", element: <Login />, enabled: true },
  { path: "/signup", element: <SignUp />, enabled: true },
  { path: "/forgot-password", element: <ForgotPassword />, enabled: true },
  { path: "/reset-password/:token", element: <ResetPassword />, enabled: true },
].filter((route) => route.enabled);

// Define routes for the main section that require WithHeader
const mainRoutes = [
  { path: "/", element: <HomePage />, enabled: true },
  { path: "/contact-us", element: <ContactUs />, enabled: true },
  { path: "/privacy-policy", element: <PrivacyPolicy />, enabled: true },
  { path: "/about-us", element: <AboutUs />, enabled: true },
  { path: "/terms-of-service", element: <TermCondition />, enabled: true },
  { path: "/pricing", element: <PricingMode />, enabled: true },
  { path: "/features", element: <Features />, enabled: true },
].filter((route) => route.enabled);

// Define routes for the dashboard section
const dashboardRoutes = [
  { path: "/dashboard/profile/edit", element: <UserProfile />, enabled: true },
  { path: "/dashboard/surveys", element: <MySurveys />, enabled: true },
  {
    path: "/dashboard/surveys/feedback",
    element: <FeedbackSurvey />,
    enabled: true,
  },
  { path: "/dashboard/support", element: <Support />, enabled: true },
  {
    path: "/dashboard/create-survey",
    element: <CreateSurvey />,
    enabled: true,
  },

  {
    path: "/dashboard/receive-response",
    element: <ReceiveResponse />,
    enabled: true,
  },
  {
    path: "/dashboard/receive-subcription-response",
    element: <ReceiveSubscriptionResponse />,
    enabled: true,
  },
  {
    path: "/dashboard/create-survey/template",
    element: <SurveyTemplate />,
    enabled: true,
  },
  {
    path: "/dashboard/create-survey/preview",
    element: <SurveyPreview />,
    enabled: true,
  },
  {
    path: "/dashboard/draft-surveys",
    element: <DraftSurveys />,
    enabled: false,
  },
  {
    path: "/dashboard/pricing",
    element: <BillingDetails />,
    enabled: true,
  },
  {
    path: "/dashboard/analysis",
    element: <Analysis />,
    enabled: true,
  },
  {
    path: "/dashboard/analysis/report",
    element: <SurveyStatusReport />,
    enabled: true,
  },
].filter((route) => route.enabled);

export { authRoutes, mainRoutes, dashboardRoutes };
